module.exports = __webpack_public_path__ + "img/success.99517c95.svg";